"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SceneOverride = void 0;
const BackgroundOverride_1 = require("./BackgroundOverride");
const MeasurementOverride_1 = require("./MeasurementOverride");
class SceneOverride {
    constructor() {
        this.background = new BackgroundOverride_1.BackgroundOverride();
        this.models = new Array();
        this.lights = new Array();
        this.measurement = new MeasurementOverride_1.MeasurementOverride();
    }
}
exports.SceneOverride = SceneOverride;
